import React from 'react';
import PropTypes from 'prop-types';
import Header from 'components/layout/Layout/header/Header';
import ImpersonationBar from 'components/layout/Layout/content/ImpersonationBar';
import Menu from 'components/menus/Menu';
import Modal from 'components/modals/Modal';
import Notification from 'components/notifications/Notification';
import OutdatedBrowserBar from 'components/layout/OutdatedBrowser/OutdatedBrowser';
import Sidebar from 'components/layout/Layout/sidebar/Sidebar';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import injectSheet from 'react-jss';
import styled from 'styled-components';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { setPath } from 'store/actions/pathActions';

const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledBody = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    background-color: ${ theme.app.background };
`;

const StyledMain = styled.div`
    display: flex;
    flex: 1 0 auto;
    font-family: ${ theme.fontFamily };
    background-color: ${ theme.app.background };
    overflow-x: auto;
`;

const StyledContentWrapper = styled.div`
    flex: 1;
    padding-bottom: 50px;
`;

const StyledContent = styled.div`
    padding: 2em;
`;

const AuthLayout = (props) => {
    const {
        children,
    } = props;

    return (
        <StyledWrapper>
            <StyledBody>
                <StyledMain>
                    <StyledContentWrapper>
                        <Header />

                        { authHelper.isImpersonated() &&
                            <ImpersonationBar />
                        }

                        <StyledContent>
                            { children }
                        </StyledContent>

                        { utils.isOutdatedBrowser() &&
                            <OutdatedBrowserBar type='bar' />
                        }
                    </StyledContentWrapper>

                    <Sidebar>
                        <Menu />
                    </Sidebar>
                </StyledMain>

                <Notification />
            </StyledBody>

            <Modal />
        </StyledWrapper>
    );
};

AuthLayout.propTypes = {
    children: PropTypes.element.isRequired,
};

function mapStateToProps(state) {
    return {
        openModal: state.modal.open,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAfterError: (path) => {
            dispatch(setPath(path));
        },
    };
};

const enhance = compose(
    injectSheet(),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(AuthLayout);



// WEBPACK FOOTER //
// ./src/layouts/AuthLayout.js